import config from '@/config'
import sensors from 'sa-sdk-javascript'

sensors.init({
  name: 'alpha_sa',
  server_url: config.sensorServerUrl,
  web_url: config.sensorWebUrl,
  show_log: false,
  is_single_page: true,
  corss_subdomain: false,
  heatmap: {
    loadTimeout: 3000,
    clickmap: 'default',
    collect_url: function () {
      return true
    },
    custom_property: function () {
      return {
        sys_product_name: 'alpha_school', // 设置项目名
        sys_platform: 'web',
      }
    },
  },
})
;(function () {
  // 扩大神策$webClick事件的采集范围
  document.body.addEventListener('click', function (event) {
    let e = event.target
    if (e.getAttribute('analysis-name')) {
      if (typeof e === 'object' && e.tagName) {
        sensors.track('$WebClick', Object.assign({
          sys_product_name: 'alpha_school',
          sys_platform: 'web',
        }, {
          $element_name: e.getAttribute('analysis-name'),
        }))
      }
    }
  })
})()
